query Conversion($conversionId: ID!) {
  conversion(conversionId: $conversionId) {
    id
    landingpage {
      name
      type
    }
    origin
    source
    utmParams {
      source
      medium
      campaign
      content
      term
    }
    clickIds {
      gclid
      wbraid
      gbraid
    }
    personalData {
      firstname
      lastname
      email
      phone
      formattedPhone: phone(formatted: true)
      gender
      yearOfBirth
      address {
        country
        zip
        city
        street
        houseNumber
      }
    }
    customFields {
      label
      value
    }
    download {
      postalShipping
    }
    returnCall {
      callbackTimeOfDay
      topics
      topicsOther
    }
    lifeAnnuity {
      payoutType
      property {
        type
        value
        livingArea
        buildingYear
        garageAmount
        zip: postcode
        selfOccupied
      }
      callbackTimeOfDay
    }
    partialSale {
      property {
        type
        value
        livingArea
        buildingYear
        garageAmount
        zip: postcode
        selfOccupied
      }
      callbackTimeOfDay
    }
    propertyRequest {
      property {
        type
        subType
        minNumberOfRooms
        minNumberOfBathrooms
        outdoorArea
        minNumberOfParkingSpaces
        accessibility
        location {
          description
          radius
          coordinates {
            lat
            lng
          }
        }
        surroundings
        residentialArea
        minPrice
        maxPrice
      }
      currentLivingSituation
      availableStartDate
      financing
    }
    plotValuation {
      type
      landArea
      conditions {
        road
        water
        power
      }
      development
      address {
        street
        houseNumber: streetNumber
        city
        zip: postcode
        country
      }
      callbackTimeOfDay
    }
    valuation {
      id
      status
      reason
      provider
      inputs {
        type
        subType
        buildingYear
        landArea
        livingArea
        balconyArea
        numberOfRooms
        quality
        condition
        numberOfUnits
        annualRentIncome
        address {
          street
          houseNumber
          city
          zip
        }
        coordinates {
          lat
          lng
        }
      }
      results {
        currency
        property {
          value
          valueConfidence
          valueRange {
            min
            max
          }
        }
      }
      pdf {
        status
        file {
          cdnUrl
        }
      }
      createdAt
    }
  }
}
